import type { Profile } from "../../lib/types.js";
import styles from "./ProfileTree.module.css";

interface ProfileTreeProps {
  profiles: Profile[];
  selected?: string;
  onSelect: (slug: string) => void;
}

export function ProfileTree({ profiles, selected, onSelect }: ProfileTreeProps) {
  return (
    <div className={styles.tree}>
      {profiles.map((p) => (
        <button
          key={p.slug}
          className={`${styles.node} ${selected === p.slug ? styles.selected : ""}`}
          onClick={() => onSelect(p.slug)}
        >
          <span className={styles.nodeName}>{p.name}</span>
          <code className={styles.nodeSlug}>{p.slug}</code>
        </button>
      ))}
    </div>
  );
}
